import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { UpsertGoalModal } from "modules/campaigns/components/Sections/goals/UpsertGoalModal"
import { GoalsListSearchSchema } from "./route"

export const Route = createFileRoute("/_base/_auth/campaigns/goals/list/create")({
  component: RouteComponent,
  validateSearch: (search) => {
    return GoalsListSearchSchema.parse(search)
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/campaigns/goals/list", search })
  }

  return <UpsertGoalModal onClose={onClose} />
}
